import { render } from "./NftPanel.vue?vue&type=template&id=594a8cb0&scoped=true"
import script from "./NftPanel.vue?vue&type=script&lang=js"
export * from "./NftPanel.vue?vue&type=script&lang=js"

import "@/Common/Styles/profilePanels.scss?vue&type=style&index=0&id=594a8cb0&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/THEOS-interfaces/THEOS-interfaces/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-594a8cb0"]])

export default __exports__